import * as R from 'ramda';
import React from 'react';
import * as Fields from './fields';
// XXX This is causing misfunction of babel plugins

// Thin wrapper around form to deal with normalization (through Field), rendering, data collecting & tranform.
// Not support complex structure such as nesting.
// TODO
// - Form to accept field instance as well
// - Field can be hidden if there is only one choice

export class FormWrapper {
  constructor(form, initialData, fields) {
    this.form = form;
    this.initialData = { ...initialData };
    this.fields = fields.map(field => this.getField(field));
  }

  getField(spec) {
    if (spec instanceof Fields.BaseField) return spec;
    if (spec.render) return spec;
    // TODO initialData will be overrode by the one from spec, is it correct? Any better logic?
    const initialData = this.initialData[spec.name];
    const Field = Fields[`${spec.type}Field`];
    return new Field({
      ...spec,
      initialValue: R.isNil(initialData) ? spec.initialValue : initialData,
    });
  }

  getFields() {
    return this.fields.map(field => field);
  }

  getFieldNames() {
    return this.fields.map(field => field.spec?.name || field.name);
  }

  hasField(name) {
    return this.fields.find(
      field => field?.spec?.name === name || field?.name === name
    );
  }

  renderField(name) {
    return this.hasField(name)?.render(this);
  }

  render() {
    return this.fields.map((field, index) => {
      const element = field.render(this);
      // If element already has a key, use it; otherwise add index-based key
      if (React.isValidElement(element) && !element.key) {
        return React.cloneElement(element, { key: `field-${index}` });
      }
      return element;
    });
  }

  serialize() {
    const values = this.form.getFieldsValue();
    return R.mergeAll(
      this.fields
        .filter(field => field.serializeField)
        .map(field => field.serializeField(values))
    );
  }

  // This method call error field's name based on the field's label, if there is no field's label, then call it 'Field'
  setErrors(errors, values = this.form.getFieldsValue()) {
    if (!R.is(Object, errors)) return;

    // Map server field names to form field names
    const errorKeyMapping = {
      toetd: 'etd',
      frometd: 'etd',
    };

    // Remap error keys to match form field names, keeping both original and mapped fields
    const remappedErrors = { ...errors };
    Object.entries(errorKeyMapping).forEach(([serverKey, formKey]) => {
      if (remappedErrors[serverKey]) {
        remappedErrors[formKey] = remappedErrors[serverKey];
        // Keep the original server key as well
      }
    });

    this.form.setFields(
      R.mergeAll(
        R.toPairs(remappedErrors).map(([key, es]) => ({
          [key]: {
            value: values[key],
            errors:
              es.map != null &&
              es.map(
                e =>
                  new Error(
                    e.replace(/\{(\w+)\}/g, (m, name) =>
                      R.compose(
                        R.pathOr('Field', ['spec', 'label']),
                        R.find(R.pathEq(['spec', 'name'], name))
                      )(this.fields)
                    )
                  )
              ),
          },
        }))
      )
    );

    if (errors.files) {
      // HACK DOM to display errors for file fields due to unable to set errors to the custom file upload widget
      const fileDom = document.querySelector(
        '.upload-attachments .nui-fieldset'
      );

      fileDom?.querySelector('.error-list')?.remove();

      const errorNode = document.createElement('ul');
      errorNode.classList.add('error-list');

      const errorItem = document.createElement('li');
      errorItem.classList.add('error-description');
      errorItem.textContent = errors.files[0];

      errorNode.appendChild(errorItem);

      fileDom?.classList.add('has-error');
      fileDom?.appendChild(errorNode);
    }
  }
}
